import { render, staticRenderFns } from "./resultLogCard.vue?vue&type=template&id=19385d3f&scoped=true&"
import script from "./resultLogCard.vue?vue&type=script&lang=js&"
export * from "./resultLogCard.vue?vue&type=script&lang=js&"
import style0 from "./resultLogCard.vue?vue&type=style&index=0&id=19385d3f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19385d3f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCardTitle,VDataTable,VIcon,VSpacer})
